import { BaseFieldRenderer } from './base-field-renderer';
import { TelFieldJsonData, RenderOptions } from '../../models/element-types';
import { TranslateUtils } from '../../utils/translate.utils';

export class TelFieldRenderer extends BaseFieldRenderer<TelFieldJsonData> {
    protected override get defaultData(): TelFieldJsonData {
        return {
            id: '',
            type: 'tel',
            label: TranslateUtils.TEL_FIELD.LABEL,
            placeholder: TranslateUtils.TEL_FIELD.PLACEHOLDER,
            required: false,
            hiddenLabel: false,
            crmFieldData: {
                mixedType: 'ContactField',
                type: 'Phone',
                systemName: 'MobilePhone',
                name: 'Mobile Phone'
            }
        };
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    protected renderInput(fieldJsonData: TelFieldJsonData, options: RenderOptions): HTMLElement {
        const input = document.createElement('input');
        input.classList.add('input', 'default');
        input.type = 'tel';

        this.applyCommonAttributes(input, fieldJsonData);

        return input;
    }
}
